import { HoverCard, HoverCardContent, HoverCardTrigger } from '@chain-zen/ui'

import type { TTiveDeviceSource } from '../../../types/tracking'
import { TiveDeviceInfo } from './tive-device-info'
import { TiveDeviceTrackingInfo } from './tive-device-tracking-info'

interface ITiveDeviceSourceProps {
  shipmentID: string
  trackingSourceData: TTiveDeviceSource
}

/**
 * TiveDeviceSource displays the tive device data for the shipment.
 */
export const TiveDeviceSource = (props: ITiveDeviceSourceProps) => {
  const { trackingSourceData, shipmentID } = props

  return (
    <HoverCard>
      <HoverCardTrigger className="w-full">
        <div className="w-full">
          <TiveDeviceInfo trackingSourceData={trackingSourceData} shipmentID={shipmentID} />
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="w-full text-sm" side="top">
        <TiveDeviceTrackingInfo trackingSourceData={trackingSourceData as TTiveDeviceSource} />
      </HoverCardContent>
    </HoverCard>
  )
}
